import React, { lazy, useEffect, useState, useMemo } from 'react';
import {
    STATSIG_EXPERIMENTS,
    STATSIG_EXPERIMENTS_DEFAULTS
} from '../../../statsig/experiments';
import { ExperimentWrapper } from '../generic/experiment-wrapper';
// @ts-ignore
import { fetchCohortAttributes } from '../csm-chat-widget/user-entitlement-service';
import { useAuth } from '../../providers/auth-providers';

interface SearchAIContainerProps {
    searchTerm: string;
}

const SearchAI = lazy(() =>
    // @ts-ignore
    import('./search-ai').then((module) => ({
        default: module.SearchAI
    }))
);

const getEmailDomain = (email: string | undefined): string | null => {
    if (!email) {
        return null;
    }

    const parts = email.split('@');
    return parts.length === 2 ? parts[1] : null;
};

export const SearchAIContainer = ({ searchTerm }: SearchAIContainerProps) => {
    const [cohortAttributes, setCohortAttributes] = useState<any>(null);
    const [isAtlassianAccount, setIsAtlassianAccount] = useState(false);
    const { email } = useAuth();

    useEffect(() => {
        const domain = getEmailDomain(email);
        if (domain === 'atlassian.com') {
            setIsAtlassianAccount(true);
        } else {
            setIsAtlassianAccount(false);
        }
    }, [email]);

    useEffect(() => {
        const fetchAttributes = async () => {
            const attributes = await fetchCohortAttributes();
            setCohortAttributes(attributes);
        };
        fetchAttributes();
    }, []);

    /** Memoizing customAttributes to avoid unnecessary re-renders */
    const customAttributes = useMemo(
        () => ({
            sacPath: window?.location?.pathname,
            hostname: window?.location?.hostname,
            isHipaaEntitlementPresent:
                cohortAttributes?.isHipaaEntitlementPresent || false,
            isAtlassianAccount
        }),
        [cohortAttributes, isAtlassianAccount]
    );

    /** Memoizing customErrorAttributes to avoid unnecessary re-renders */
    const customErrorAttributes = useMemo(
        () => ({
            componentName: 'SearchAIContainer'
        }),
        []
    );

    return (
        <ExperimentWrapper
            experimentName={STATSIG_EXPERIMENTS.SAC_SEARCH_AI}
            experimentParameter="ai_dialog_enabled"
            defaultValues={
                // @ts-ignore
                STATSIG_EXPERIMENTS_DEFAULTS[STATSIG_EXPERIMENTS.SAC_SEARCH_AI][
                    'ai_dialog_enabled'
                ]
            }
            customAttributes={customAttributes}
            customErrorAttributes={customErrorAttributes}
            source="AiSummarizationDialog"
        >
            <SearchAI searchTerm={searchTerm} />
        </ExperimentWrapper>
    );
};
